module.exports = __webpack_public_path__ + "media/images/pages/ai/book-now@2x-c8705f234b5e0392d62973358d402b8c.png";